import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFilter as setStateFilter } from "../../actions/overview";
import { fetcher } from "../Overview/Overview";
import debounce from "lodash.debounce";
import Select from "react-select";

/// EXAMPLE
// const locationFilter = useAsyncFilter({
//     name: "Cursus: Locatie",                 // Name to be used
//     columnIdentifier: "location",            // (db) column to be used
//     identifier: "course-filter",             // global filter group to be used
//     endpoint: "/v1/locations",               // endpoint
//     endpointParams: [ { key: "is_active", value: true }, { key: "pagination", value: false} ],
//     value: "uuid",                           // value to store it in
//     // label: "name",
//     labels: ["name", "postal_code", "city"], // columns to be selected/usable for label
//     labelDef: props => `${props.name} - ${props.city} (${props.postal_code})`,   // Label creation
//     minLength: 3,                            // minimum amount of chars before triggering
//     placeholder: "Typ een deel van de locatienaam, stad of postcode"
// });

// Creates a dropdown which uses async calls to filter the result
export function useAsyncFilter(props) {
    const limit = props?.minLength !== undefined || props?.limit === true;

    const dispatch = useDispatch();
    let state = useSelector((state) => state.OverviewState?.[JSON.stringify(props.identifier)]?.filter?.[props.columnIdentifier]) || "";

    let fields = [props.value];

    if (props.labels) {
        fields.push(...props.labels);
    }

    if (props.label) {
        fields.push(props.label);
    }

    const setFilter = (val) => {
        dispatch(
            setStateFilter(props.identifier, {
                columnIdentifier: props.columnIdentifier,
                value: val
            })
        );
    };

    const _getOptions = async (input, callback) => {
        if (limit && (input === "" || (props.minLength && input.length < props.minLength))) {
            callback("error");
        } else {
            const res = await fetcher(
                `${props.endpoint}/?fields=${fields.join(",")}&${props.endpointParams.map((p) => p.key + "=" + p.value).join("&")}&search=${input}`
            );
            const result = res?.results || res;

            callback(null, {
                options: props?.labelDef
                    ? result.map((r) => {
                          return {
                              [props.value]: r[props.value],
                              label: props.labelDef(r)
                          };
                      })
                    : result
            });
        }
    };

    const getOptions = debounce(_getOptions, 500);

    const content = (
        <Select.Async
            name={"trainers"}
            valueKey={props.value}
            labelKey={props?.label ? props.label : "label"}
            searchPromptText={"Typ om te zoeken..."}
            placeholder={props?.placeholder || (limit ? "Typ om te zoeken..." : "Selecteer een optie of typ om te zoeken")}
            onChange={(opt) => setFilter(opt)}
            value={state}
            loadOptions={getOptions}
            cache={false}
        />
    );

    return {
        content,
        resultObj: {
            columnIdentifier: props.columnIdentifier,
            result: state[props.value]
        },
        result: state.label,
        name: props?.name || "Geen naam opgegeven",
        reset: () => setFilter(null),
        setResult: (o) => setFilter(o)
    };
}
